import { Injectable }           from '@angular/core';
import { Observable }           from 'rxjs';
import { map }                  from 'rxjs/operators';
import { AssignmentStatus }     from './assignment-status';
import { ApiHttpClientService } from '../../api-http-client/api-http-client.service';

@Injectable({
  providedIn: 'root'
})
export class AssignmentStatusesService {

  constructor(private http: ApiHttpClientService) { }

  getAssignmentStatuses(): Observable<AssignmentStatus[]> {
    return this.http.get('assignment_statuses').pipe(
      map((res: any) => res.assignment_statuses.map(assignmentStatus => new AssignmentStatus(assignmentStatus)))
    );
  }
}
